import './DistributionEditModal.scss';

import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';

import CapitalGainsOption from './CapitalGainsOption';
import DividendsOption from './DividendsOption.js';
import IraOverContribution
  from './DistributionEditModal/IraOverContribution';
import PageLoadingSpinner from 'components/layouts/Navigation/PageLoadingSpinner';
import {Spinner} from '@trp-beacon-ui-kit/react-communication';
import {isIRA} from 'services/AccountTypes';
import TRP from 'components/shared/TRP/TRP';
import {
  CAPITAL_GAINS_TYPE_ID,
  DISTRIBUTE_TO_BANK_ID,
  DISTRIBUTE_TO_FUND_ID,
  DIVIDEND_TYPE_ID,
  REINVEST_ID,
  TO_CHECK_ID
} from 'services/Preferences';
import {getAccountsEligibleForExchange} from 'services/Rest';
import {getView} from 'state/view/ViewSelectors';
import {getAvailableFundsForSelect, getBankAccountsById} from 'state/preferences/PreferencesSelectors';
import {getAssociatedBanksFromFund} from 'services/LinkedBankAccounts';
import {getAccountsById} from 'state/account/AccountSelectors';
import {hasDistributionOptionChanged2} from 'services/DividendsCapitalGains';
import {AAMBeaconButton, AAMBeaconControl, AAMBeaconModal} from 'components/shared/Beacon';
import {linkBuilder, linkedBankAccountsLinks} from 'services/Externals';
import {getCustomerWebView} from 'state/customer/CustomerSelectors';
import {bankInfo, checkIfMissingFundOrBank, fundInfo} from "./DivCapUtils";

export const checkIfShouldDisable = (
  capitalGainsDistributionTypeId,
  originalCapitalGainsDistributionTypeId,
  capitalGainsFund,
  originalCapitalGainsFund,
  capitalGainsBankAgreementKey,
  originalCapitalGainsBankAgreementKey,
  dividendsDistributionTypeId,
  originalDividendsDistributionTypeId,
  dividendsFund,
  originalDividendsFund,
  dividendsBankAgreementKey,
  originalDividendsBankAgreementKey
) => {
  const capitalGainsOptionChanged = hasDistributionOptionChanged2(
    capitalGainsDistributionTypeId,
    originalCapitalGainsDistributionTypeId,
    capitalGainsFund,
    originalCapitalGainsFund,
    capitalGainsBankAgreementKey,
    originalCapitalGainsBankAgreementKey
  );

  const dividendsOptionChanged = hasDistributionOptionChanged2(
    dividendsDistributionTypeId,
    originalDividendsDistributionTypeId,
    dividendsFund,
    originalDividendsFund,
    dividendsBankAgreementKey,
    originalDividendsBankAgreementKey
  );

  return !capitalGainsOptionChanged && !dividendsOptionChanged;
};

export const onCapitalGainsChange = (
  distributionTypeId,
  dividendsDistributionTypeId,
  setDividendsDistributionTypeId,
  setCapitalGainsDistributionTypeId,
  setDividendsBankAgreementKey,
  setCapitalGainsBankAgreementKey,
  dividendsBankAgreementKey,
  dividendsFund,
  setDividendsFund,
  setCapitalGainsFund
) => {
  if (
    dividendsDistributionTypeId === DISTRIBUTE_TO_BANK_ID &&
    distributionTypeId === DISTRIBUTE_TO_BANK_ID
  ) {
    setCapitalGainsBankAgreementKey(dividendsBankAgreementKey);
  }

  if (
    dividendsDistributionTypeId === DISTRIBUTE_TO_FUND_ID &&
    distributionTypeId === DISTRIBUTE_TO_FUND_ID
  ) {
    setCapitalGainsFund(dividendsFund);
  }
  setCapitalGainsDistributionTypeId(distributionTypeId);
};

export const handleSave = (
  onSave,
  accountInfo,
  associatedBanksFromFund,
  availableFunds,
  brokerageAssetType,
  capitalGains,
  dividends,
  capitalGainsDistributionTypeId,
  originalCapitalGainsDistributionTypeId,
  capitalGainsFund,
  originalCapitalGainsFund,
  capitalGainsBankAgreementKey,
  originalCapitalGainsBankAgreementKey,
  dividendsDistributionTypeId,
  originalDividendsDistributionTypeId,
  dividendsFund,
  originalDividendsFund,
  dividendsBankAgreementKey,
  originalDividendsBankAgreementKey
) => {
  const capitalGainsOptionChanged = hasDistributionOptionChanged2(
    capitalGainsDistributionTypeId,
    originalCapitalGainsDistributionTypeId,
    capitalGainsFund,
    originalCapitalGainsFund,
    capitalGainsBankAgreementKey,
    originalCapitalGainsBankAgreementKey
  );

  const dividendsOptionChanged = hasDistributionOptionChanged2(
    dividendsDistributionTypeId,
    originalDividendsDistributionTypeId,
    dividendsFund,
    originalDividendsFund,
    dividendsBankAgreementKey,
    originalDividendsBankAgreementKey
  );

  const dividendDisposition = dividendsOptionChanged
    ? { action: 'update' }
    : null;
  const capitalGainDisposition = capitalGainsOptionChanged
    ? { action: 'update' }
    : null;
  const dividendOption = {
    sourceAccountDescriptor: {
      accountChecksum: accountInfo.accountChecksum,
      accountNumber: accountInfo.accountNumber,
      productType: accountInfo.productType,
      accountId: accountInfo.accountId,
      trpCode: accountInfo.trpCode,
      accountTypeId: accountInfo.accountTypeId,
      balanceValue: null,
      retirementAccount: null,
      suppressFromView: !accountInfo.viewEnabled,
      ticker: null,
      cusipId: null
    },
    distributionTypeId: dividendsDistributionTypeId,
    disposition: dividendDisposition,
    typeId: DIVIDEND_TYPE_ID
  };
  if (dividendOption.distributionTypeId === DISTRIBUTE_TO_FUND_ID) {
    const fund = fundInfo(availableFunds, dividendsFund);
    dividendOption.targetAccountDescriptor =  fund.accountDescriptor;
  } else if (dividendOption.distributionTypeId === DISTRIBUTE_TO_BANK_ID) {
    dividendOption.bankAgreementKey = bankInfo(associatedBanksFromFund, dividendsBankAgreementKey)?.bankAgreementKey;
  }

  const capitalGainOption = {
    sourceAccountDescriptor: {
      accountChecksum: accountInfo.accountChecksum,
      productType: accountInfo.productType,
      accountId: accountInfo.accountId,
      trpCode: accountInfo.trpCode,
      accountTypeId: accountInfo.accountTypeId,
      accountNumber: accountInfo.accountNumber,
      balanceValue: null,
      retirementAccount: null,
      suppressFromView: !accountInfo.viewEnabled,
      ticker: null,
      cusipId: null
    },
    distributionTypeId: capitalGainsDistributionTypeId,
    disposition: capitalGainDisposition,
    typeId: CAPITAL_GAINS_TYPE_ID
  };

  if (capitalGainOption.distributionTypeId === DISTRIBUTE_TO_FUND_ID) {
    const fund = fundInfo(availableFunds, capitalGainsFund);
    capitalGainOption.targetAccountDescriptor = fund.accountDescriptor;
  } else if (capitalGainOption.distributionTypeId === DISTRIBUTE_TO_BANK_ID) {
    capitalGainOption.bankAgreementKey = bankInfo(associatedBanksFromFund, capitalGainsBankAgreementKey)?.bankAgreementKey;
  }

  const payload = {
    distributionOptions: [dividendOption, capitalGainOption]
  };

  onSave(payload);
};

export const handleCancel = (selector) => {
  const modal = document.getElementById(selector) ?? null;
  if (modal !== null) {
    modal.close();
  }
};

const NonRetirementNotIncome2020Modal = ({
  accountsById,
  availableFunds,
  bankAccountsById,
  distributionToEdit,
  onBeaconClose,
  onSave,
  requestStatus,
  view,
  isCustomerWebView
}) => {
  const { accountInfo, capitalGains, dividends, brokerageAssetType } =
    distributionToEdit;
  const [modalReset, setModalReset] = useState(false);
  const [availableFundsLoading, setAvailableFundsLoading] = useState(true);
  const [capitalGainsDistributionTypeId, setCapitalGainsDistributionTypeId] =
    useState(null);
  const [capitalGainsBankAgreementKey, setCapitalGainsBankAgreementKey] =
    useState(null);
  const [capitalGainsFund, setCapitalGainsFund] = useState(null);
  const [
    originalCapitalGainsBankAgreementKey,
    setOriginalCapitalGainsBankAgreementKey
  ] = useState(null);
  const [originalCapitalGainsFund, setOriginalCapitalGainsFund] =
    useState(null);
  const [dividendsDistributionTypeId, setDividendsDistributionTypeId] =
    useState(null);
  const [dividendsBankAgreementKey, setDividendsBankAgreementKey] =
    useState(null);
  const [dividendsFund, setDividendsFund] = useState(null);
  const [
    originalDividendsBankAgreementKey,
    setOriginalDividendsBankAgreementKey
  ] = useState(null);
  const [originalDividendsFund, setOriginalDividendsFund] = useState(null);
  const [iraCheckboxChecked, setIraCheckboxChecked] = useState(false);
  const [
    originalCapitalGainsDistributionTypeId,
    setOriginalCapitalGainsDistributionTypeId
  ] = useState(null);
  const [
    originalDividendsDistributionTypeId,
    setOriginalDividendsDistributionTypeId
  ] = useState(null);
  const [submittedChange, setSubmittedChange] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);

  const modalName = 'distribution-non-retire-edit-modal-v2';

  useEffect(() => {
    const { accountId } = accountInfo;
    getAccountsEligibleForExchange(accountsById[accountId]);
    setModalReset(true);
    const dividendsState = {
      bankAgreementKey: dividends.bankInfo
        ? dividends.bankInfo.bankAgreementKey
        : null,
      fund: dividends.fundInfo
          ? dividends.fundInfo.accountId
          : null
    };

    if (dividendsState.bankAgreementKey) {
      setDividendsBankAgreementKey(dividendsState.bankAgreementKey.bankId);
      setOriginalDividendsBankAgreementKey(dividendsState.bankAgreementKey.bankId);
    }

    if (dividendsState.fund) {
      setDividendsFund(dividendsState.fund);
      setOriginalDividendsFund(dividendsState.fund);
    }

    const capitalGainsState = {
      bankAgreementKey: capitalGains.bankInfo
        ? capitalGains.bankInfo.bankAgreementKey
        : null,
      fund: capitalGains.fundInfo
          ? capitalGains.fundInfo.accountId
          : null
    };

    if (capitalGainsState.bankAgreementKey) {
      setCapitalGainsBankAgreementKey(capitalGainsState.bankAgreementKey.bankId);
      setOriginalCapitalGainsBankAgreementKey(capitalGainsState.bankAgreementKey.bankId);
    }

    if (capitalGainsState.fund) {
      setCapitalGainsFund(capitalGainsState.fund);
      setOriginalCapitalGainsFund(capitalGainsState.fund);
    }

    setDividendsDistributionTypeId(dividends.distributionTypeId);
    setCapitalGainsDistributionTypeId(capitalGains.distributionTypeId);
    setOriginalDividendsDistributionTypeId(dividends.distributionTypeId);
    setOriginalCapitalGainsDistributionTypeId(capitalGains.distributionTypeId);
  }, [distributionToEdit, accountInfo.accountId]);

  useEffect(() => {
    if (requestStatus.updateDividendsCapitalGains === 'REQUESTED') {
      setShowSpinner(true);
    }
    if (submittedChange) {
      if (
        requestStatus.updateDividendsCapitalGains === 'RECEIVED' ||
        requestStatus.updateDividendsCapitalGains === 'ERROR'
      ) {
        setShowSpinner(false);
        setSubmittedChange(false);
        handleCancel(modalName);
      }
    }
    if (requestStatus.availableFunds === 'RECEIVED' && modalReset) {
      setAvailableFundsLoading(false);
    } else if (requestStatus.availableFunds === 'ERROR') {
      setShowSpinner(false);
      setSubmittedChange(false);
      handleCancel(modalName);
    }
  }, [requestStatus, modalReset]);


  const { accountId } = accountInfo;
  const bankAccounts = bankAccountsById[accountId] || [];

  let isSelectedFundIra = false;
  if (dividendsDistributionTypeId === DISTRIBUTE_TO_FUND_ID && dividendsFund) {
    const { fund } = dividendsFund;
    isSelectedFundIra = isIRA(fund?.accountTypeId);
  } else if (
    capitalGainsDistributionTypeId === DISTRIBUTE_TO_FUND_ID &&
    capitalGainsFund
  ) {
    const { fund } = capitalGainsFund;
    isSelectedFundIra = isIRA(fund?.accountTypeId);
  }

  const missingFundOrBank = checkIfMissingFundOrBank(
    capitalGainsDistributionTypeId,
    dividendsDistributionTypeId,
    capitalGainsBankAgreementKey,
    dividendsBankAgreementKey,
    dividendsFund,
    capitalGainsFund
  );
  const shouldDisable = checkIfShouldDisable(
    capitalGainsDistributionTypeId,
    originalCapitalGainsDistributionTypeId,
    capitalGainsFund,
    originalCapitalGainsFund,
    capitalGainsBankAgreementKey,
    originalCapitalGainsBankAgreementKey,
    dividendsDistributionTypeId,
    originalDividendsDistributionTypeId,
    dividendsFund,
    originalDividendsFund,
    dividendsBankAgreementKey,
    originalDividendsBankAgreementKey
  );

  const disableSave =
    missingFundOrBank ||
    (isSelectedFundIra && !iraCheckboxChecked) ||
    shouldDisable;

  const associatedBanksFromFund = getAssociatedBanksFromFund(
    bankAccounts,
    accountInfo
  );

  let defaultSelectedBank = '';
  if (dividendsBankAgreementKey){
    const bank = bankInfo(associatedBanksFromFund, dividendsBankAgreementKey);
    defaultSelectedBank = `${bank.bankName} ${bank.bankAgreementKey.routingNumber} - ${bank.bankAgreementKey.lastFour}`;
  } else {
    defaultSelectedBank = 'Select a Bank Account';
  }

  let defaultSelectedCapitalBank = '';
  if (capitalGainsBankAgreementKey){
    const bank = bankInfo(associatedBanksFromFund, capitalGainsBankAgreementKey);
    defaultSelectedCapitalBank = `${bank.bankName} ${bank.bankAgreementKey.routingNumber} - ${bank.bankAgreementKey.lastFour}`;
  } else {
    defaultSelectedCapitalBank = 'Select a Bank Account';
  }

  let defaultSelectedDivedendFund = '';

  if (dividendsFund && !availableFundsLoading){
    const fund = fundInfo(availableFunds, dividendsFund);
    defaultSelectedDivedendFund = `${fund.accountName} ${fund.ticker} - ${fund.accountWChecksum} ${fund.accountType}`;
  } else {
    defaultSelectedDivedendFund = 'Select Fund';
  }

  let defaultSelectedCapFund = '';
  if (capitalGainsFund && !availableFundsLoading){
    const fund = fundInfo(availableFunds, capitalGainsFund);
    defaultSelectedCapFund = `${fund.accountName} ${fund.ticker} - ${fund.accountWChecksum} ${fund.accountType}`;
  } else {
    defaultSelectedCapFund = 'Select Fund';
  }

  return (
    <AAMBeaconModal
      scale={'jumbo'}
      open={true}
      id={`distribution-non-retire-edit-modal-v2`}
      className={'distribution-edit-modal-v2'}
      title={'Edit Dividends & Capital Gains'}
      onBeaconEventClose={onBeaconClose}
    >
      {availableFundsLoading && <PageLoadingSpinner name="Available Funds" />}
      {!availableFundsLoading && (
        <div className="dividends-capital-gains-container beacon-on-light">
          <div className="dividends-capital-gains-header-v2">
            Edit Dividends & Capital Gains
          </div>
          <div className="dividends-capital-gains-sub-header-v2 blocked_data">
            {accountInfo.accountName} {accountInfo.ticker} -{' '}
            {accountInfo.accountWChecksum}
          </div>
          <div className="distribution-options">
            <DividendsOption
              label="Reinvest Dividend Payments"
              value={REINVEST_ID}
              onChange={(distributionTypeId) => {
                setDividendsDistributionTypeId(distributionTypeId);
                setCapitalGainsDistributionTypeId(distributionTypeId);
                setDividendsBankAgreementKey(originalDividendsBankAgreementKey);
                setCapitalGainsBankAgreementKey(originalCapitalGainsBankAgreementKey);
              }}
              selected={dividendsDistributionTypeId === REINVEST_ID}>
              <div className={'capital-gains-header-v2'}>
                Capital Gains Distribution Options
              </div>
              <CapitalGainsOption
                label="Reinvest Capital Gains"
                value={REINVEST_ID}
                onChange={(distributionTypeId) =>
                  onCapitalGainsChange(
                    distributionTypeId,
                    dividendsDistributionTypeId,
                    setDividendsDistributionTypeId,
                    setCapitalGainsDistributionTypeId,
                    setDividendsBankAgreementKey,
                    setCapitalGainsBankAgreementKey,
                    dividendsBankAgreementKey,
                    dividendsFund,
                    setDividendsFund,
                    setCapitalGainsFund
                  )
                }
                selected={capitalGainsDistributionTypeId === REINVEST_ID}
              />
              <CapitalGainsOption
                label="Send Capital Gains By Check"
                value={TO_CHECK_ID}
                onChange={(distributionTypeId) =>
                  onCapitalGainsChange(
                    distributionTypeId,
                    dividendsDistributionTypeId,
                    setDividendsDistributionTypeId,
                    setCapitalGainsDistributionTypeId,
                    setDividendsBankAgreementKey,
                    setCapitalGainsBankAgreementKey,
                    dividendsBankAgreementKey,
                    dividendsFund,
                    setDividendsFund,
                    setCapitalGainsFund
                  )
                }
                selected={capitalGainsDistributionTypeId === TO_CHECK_ID}
              />
              <CapitalGainsOption
                label="Send Capital Gains to Bank Account"
                value={DISTRIBUTE_TO_BANK_ID}
                onChange={(distributionTypeId) =>
                  onCapitalGainsChange(
                    distributionTypeId,
                    dividendsDistributionTypeId,
                    setDividendsDistributionTypeId,
                    setCapitalGainsDistributionTypeId,
                    setDividendsBankAgreementKey,
                    setCapitalGainsBankAgreementKey,
                    dividendsBankAgreementKey,
                    dividendsFund,
                    setDividendsFund,
                    setCapitalGainsFund
                  )
                }
                selected={
                  capitalGainsDistributionTypeId === DISTRIBUTE_TO_BANK_ID
                }>
                <div className={'bank-add-account-section-v2 blocked_data'}>
                  {bankAccounts.length > 0 && (
                    <AAMBeaconControl>
                      <select value={capitalGainsBankAgreementKey}
                              id="select-a-bank-drop-down"
                              name="select-a-bank-drop-down"
                              className="select-a-bank-drop-down blocked_data"
                              onChange={(event) => {
                                const selectedBank = bankInfo(associatedBanksFromFund, event.target.value);
                                setCapitalGainsBankAgreementKey(selectedBank.bankAgreementKey.bankId);
                              }}>
                        <option value={'default'} disabled selected hidden>
                          {defaultSelectedCapitalBank}
                        </option>
                        {associatedBanksFromFund.map((bank, index) => (
                          <option
                            key={index + 1}
                            value={bank.bankAgreementKey.bankId}>
                            {bank.bankName} {bank.bankAgreementKey.routingNumber}{' '}
                            - {bank.bankAgreementKey.lastFour}{' '}
                          </option>
                        ))}
                      </select>
                    </AAMBeaconControl>
                  )}
                  <AAMBeaconButton
                    variant="secondary"
                    scale={'normal'}
                    className="add-bank-beacon-button"
                    linkHref={linkBuilder(
                      linkedBankAccountsLinks.addNewBank,
                      view
                    )}
                    // linkTarget={'_blank'}
                  >
                    Add Bank Account
                  </AAMBeaconButton>
                </div>
              </CapitalGainsOption>
              {availableFunds.length > 0 && (
                <CapitalGainsOption
                  label="Send Capital Gains to Another Fund"
                  value={DISTRIBUTE_TO_FUND_ID}
                  onChange={(distributionTypeId) =>
                    onCapitalGainsChange(
                      distributionTypeId,
                      dividendsDistributionTypeId,
                      setDividendsDistributionTypeId,
                      setCapitalGainsDistributionTypeId,
                      setDividendsBankAgreementKey,
                      setCapitalGainsBankAgreementKey,
                      dividendsBankAgreementKey,
                      dividendsFund,
                      setDividendsFund,
                      setCapitalGainsFund
                    )
                  }
                  selected={
                    capitalGainsDistributionTypeId === DISTRIBUTE_TO_FUND_ID
                  }>
                  <div className="another-fund-wrapper blocked_data">
                    {/* Select Another Fund Dropdown */}
                    <AAMBeaconControl>
                      <select className="select-another-fund-drop-down blocked_data"
                              id="select-another-fund-drop-down"
                              name="select-another-fund-drop-down"
                              onChange={(event) => {
                                const fundAcc = fundInfo(availableFunds, event.target.value);
                                setDividendsFund(fundAcc.accountId);
                                setCapitalGainsFund(fundAcc.accountId);
                              }}>
                        <option value={'default'} disabled selected hidden>
                          {defaultSelectedCapFund}
                        </option>
                        {availableFunds.map((account, index) => (
                          <option key={index + 1} value={account.accountId}>
                            {account.accountName} {account.ticker} -{' '}
                            {account.accountWChecksum} {account.accountType}
                          </option>
                        ))}
                      </select>
                    </AAMBeaconControl>
                    {isSelectedFundIra && (
                      <IraOverContribution
                        isChecked={iraCheckboxChecked}
                        onChange={(checked) => setIraCheckboxChecked(checked)}
                      />
                    )}
                  </div>
                </CapitalGainsOption>
              )}
            </DividendsOption>
            {/*Send Dividend Payments by Check*/}
            <DividendsOption
              label="Send Dividend Payments by Check"
              value={TO_CHECK_ID}
              onChange={(distributionTypeId) => {
                setDividendsDistributionTypeId(distributionTypeId);
                setCapitalGainsDistributionTypeId(distributionTypeId);
              }}
              selected={dividendsDistributionTypeId === TO_CHECK_ID}>
              <div className={'capital-gains-header-v2'}>
                Capital Gains Distribution Options
              </div>
              <CapitalGainsOption
                label="Send Capital Gains By Check"
                value={TO_CHECK_ID}
                onChange={(distributionTypeId) =>
                  onCapitalGainsChange(
                    distributionTypeId,
                    dividendsDistributionTypeId,
                    setDividendsDistributionTypeId,
                    setCapitalGainsDistributionTypeId,
                    setDividendsBankAgreementKey,
                    setCapitalGainsBankAgreementKey,
                    dividendsBankAgreementKey,
                    dividendsFund,
                    setDividendsFund,
                    setCapitalGainsFund
                  )
                }
                selected={capitalGainsDistributionTypeId === TO_CHECK_ID}
              />
              <CapitalGainsOption
                label="Reinvest Capital Gains"
                value={REINVEST_ID}
                onChange={(distributionTypeId) =>
                  onCapitalGainsChange(
                    distributionTypeId,
                    dividendsDistributionTypeId,
                    setDividendsDistributionTypeId,
                    setCapitalGainsDistributionTypeId,
                    setDividendsBankAgreementKey,
                    setCapitalGainsBankAgreementKey,
                    dividendsBankAgreementKey,
                    dividendsFund,
                    setDividendsFund,
                    setCapitalGainsFund
                  )
                }
                selected={capitalGainsDistributionTypeId === REINVEST_ID}
              />
            </DividendsOption>
            {/*Send Dividend Payments to Bank Account*/}
            <DividendsOption
              label="Send Dividend Payments to Bank Account"
              value={DISTRIBUTE_TO_BANK_ID}
              onChange={(distributionTypeId) => {
                setDividendsDistributionTypeId(distributionTypeId);
                setCapitalGainsDistributionTypeId(distributionTypeId);
              }}
              selected={dividendsDistributionTypeId === DISTRIBUTE_TO_BANK_ID}>
              <div className={'bank-add-account-section-v2 blocked_data'}>
                {bankAccounts.length > 0 && (
                  <AAMBeaconControl>
                    <select value={dividendsBankAgreementKey}
                            className="select-a-bank-drop-down blocked_data"
                            id="select-a-bank-drop-down"
                            name="select-a-bank-drop-down"
                            onChange={(event) => {
                              const selectedBank = bankInfo(associatedBanksFromFund, event.target.value);
                              setDividendsBankAgreementKey(selectedBank.bankAgreementKey.bankId);
                              setCapitalGainsBankAgreementKey(selectedBank.bankAgreementKey.bankId);
                            }}>
                      <option value={'default'} disabled selected hidden>
                        {defaultSelectedBank}
                      </option>
                      {associatedBanksFromFund.map((bank, index) => (
                        <option
                          key={index + 1}
                          value={bank.bankAgreementKey.bankId}>
                          {bank.bankName} {bank.bankAgreementKey.routingNumber} -{' '}
                          {bank.bankAgreementKey.lastFour}{' '}
                        </option>
                      ))}
                    </select>
                  </AAMBeaconControl>
                )}
                <AAMBeaconButton
                  variant="secondary"
                  scale={'normal'}
                  className="add-bank-beacon-button"
                  linkHref={linkBuilder(
                    linkedBankAccountsLinks.addNewBank,
                    view
                  )}
                  linkTarget={'_blank'}>
                  Add Bank Account
                </AAMBeaconButton>
              </div>
              <div className={'capital-gains-header-v2'}>
                Capital Gains Distribution Options
              </div>
              <CapitalGainsOption
                label="Send Capital Gains to Bank Account (must be same account)"
                value={DISTRIBUTE_TO_BANK_ID}
                onChange={(distributionTypeId) =>
                  onCapitalGainsChange(
                    distributionTypeId,
                    dividendsDistributionTypeId,
                    setDividendsDistributionTypeId,
                    setCapitalGainsDistributionTypeId,
                    setDividendsBankAgreementKey,
                    setCapitalGainsBankAgreementKey,
                    dividendsBankAgreementKey,
                    dividendsFund,
                    setDividendsFund,
                    setCapitalGainsFund
                  )
                }
                selected={
                  capitalGainsDistributionTypeId === DISTRIBUTE_TO_BANK_ID
                }
              />
              <CapitalGainsOption
                label="Reinvest Capital Gains"
                value={REINVEST_ID}
                onChange={(distributionTypeId) =>
                  onCapitalGainsChange(
                    distributionTypeId,
                    dividendsDistributionTypeId,
                    setDividendsDistributionTypeId,
                    setCapitalGainsDistributionTypeId,
                    setDividendsBankAgreementKey,
                    setCapitalGainsBankAgreementKey,
                    dividendsBankAgreementKey,
                    dividendsFund,
                    setDividendsFund,
                    setCapitalGainsFund
                  )
                }
                selected={capitalGainsDistributionTypeId === REINVEST_ID}
              />
            </DividendsOption>
            {/*Send Dividend Payments to Another Fund*/}
            {availableFunds.length > 0 && (
              <DividendsOption
                label="Send Dividend Payments to Another Fund"
                value={DISTRIBUTE_TO_FUND_ID}
                onChange={(distributionTypeId) => {
                  setDividendsDistributionTypeId(distributionTypeId);
                  setCapitalGainsDistributionTypeId(distributionTypeId);
                }}
                selected={
                  dividendsDistributionTypeId === DISTRIBUTE_TO_FUND_ID
                }>
                <div className="another-fund-wrapper blocked_data">
                  {/* Select Another Fund Dropdown */}
                  <AAMBeaconControl>
                    <select className="select-another-fund-drop-down blocked_data"
                            name="select-another-fund-drop-down"
                            id="select-another-fund-drop-down"
                            onChange={(event) => {
                              const fundAcc = fundInfo(availableFunds, event.target.value);
                              setDividendsFund(fundAcc.accountId);
                              setCapitalGainsFund(fundAcc.accountId);
                            }}>
                      <option value={'default'} disabled selected hidden>
                        {defaultSelectedDivedendFund}
                      </option>
                      {availableFunds.map((account, index) => (
                        <option key={index + 1} value={account.accountId}>
                          {account.accountName} {account.ticker} -{' '}
                          {account.accountWChecksum} {account.accountType}{' '}
                        </option>
                      ))}
                    </select>
                  </AAMBeaconControl>
                  {isSelectedFundIra && (
                    <IraOverContribution
                      isChecked={iraCheckboxChecked}
                      onChange={(checked) => setIraCheckboxChecked(checked)}
                    />
                  )}
                </div>
                <div className={'capital-gains-header-v2'}>
                  Capital Gains Distribution Options
                </div>
                <CapitalGainsOption
                  label="Send Capital Gains to Another Fund (must be same fund)"
                  value={DISTRIBUTE_TO_FUND_ID}
                  onChange={(distributionTypeId) =>
                    onCapitalGainsChange(
                      distributionTypeId,
                      dividendsDistributionTypeId,
                      setDividendsDistributionTypeId,
                      setCapitalGainsDistributionTypeId,
                      setDividendsBankAgreementKey,
                      setCapitalGainsBankAgreementKey,
                      dividendsBankAgreementKey,
                      dividendsFund,
                      setDividendsFund,
                      setCapitalGainsFund
                    )
                  }
                  selected={
                    capitalGainsDistributionTypeId === DISTRIBUTE_TO_FUND_ID
                  }
                />
                <CapitalGainsOption
                  label="Reinvest Capital Gains"
                  value={REINVEST_ID}
                  onChange={(distributionTypeId) =>
                    onCapitalGainsChange(
                      distributionTypeId,
                      dividendsDistributionTypeId,
                      setDividendsDistributionTypeId,
                      setCapitalGainsDistributionTypeId,
                      setDividendsBankAgreementKey,
                      setCapitalGainsBankAgreementKey,
                      dividendsBankAgreementKey,
                      dividendsFund,
                      setDividendsFund,
                      setCapitalGainsFund
                    )
                  }
                  selected={capitalGainsDistributionTypeId === REINVEST_ID}
                />
              </DividendsOption>
            )}
          </div>
          <div className="dcg-copy-v2">
            If you would like to select the payment option of &quot;by
            check&quot; or &quot;to a bank account&quot; for your IRA, please
            contact <TRP /> at 1-888-898-9677.
          </div>
          <br />
          <br />
          <div className="div-caps-update-options-v2">
            <div />
            <div className="action-buttons-v2">
              <AAMBeaconButton
                variant="tertiary"
                className="cancel-beacon-button"
                onBeaconEventClick={() => {
                  handleCancel(modalName);
                }}>
                Cancel
              </AAMBeaconButton>
              {showSpinner && (
                <div className="loading-spinner cost-basis-v2-loading-spinner">
                  <Spinner />
                </div>
              )}
              {!showSpinner && (
                <AAMBeaconButton
                  variant="positive"
                  className="save-beacon-button"
                  disabled={disableSave || isCustomerWebView}
                  onBeaconEventClick={() => {
                    handleSave(
                      onSave,
                      accountInfo,
                      associatedBanksFromFund,
                      availableFunds,
                      brokerageAssetType,
                      capitalGains,
                      dividends,
                      capitalGainsDistributionTypeId,
                      originalCapitalGainsDistributionTypeId,
                      capitalGainsFund,
                      originalCapitalGainsFund,
                      capitalGainsBankAgreementKey,
                      originalCapitalGainsBankAgreementKey,
                      dividendsDistributionTypeId,
                      originalDividendsDistributionTypeId,
                      dividendsFund,
                      originalDividendsFund,
                      dividendsBankAgreementKey,
                      originalDividendsBankAgreementKey
                    );
                    setSubmittedChange(true);
                  }}>
                  Update
                </AAMBeaconButton>
              )}
            </div>
          </div>
        </div>
      )}
    </AAMBeaconModal>
  );
};

const mapStateToProps = (state) => ({
  availableFunds: getAvailableFundsForSelect(state),
  bankAccountsById: getBankAccountsById(state),
  requestStatus: state.requestStatus,
  view: getView(state),
  accountsById: getAccountsById(state),
  isCustomerWebView: getCustomerWebView(state)
});

export default connect(mapStateToProps)(NonRetirementNotIncome2020Modal);
